import { Button } from '@mui/material';
import React from 'react';
import { ICommonButton } from './ButtonInterface';
import styled from 'styled-components';

const common = {
  'text-transform': 'uppercase',
  'font-weight': '500',
  'font-size': '1rem',
  'padding': '14px 20px',
  'box-shadow': 'none',
  'line-height': '1.5',
};

const DabaduButton = styled(Button)`
  &.MuiButtonBase-root {
    ${common}
    @media screen and (max-width: 1650px) {
      padding: 11px 14px;
    }
    min-width: ${(props) => props.minWidth};
    font-family: ${(props) => props.theme.fonts.primary};
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    &:focus {
      outline: none;
    }
  }
  &.MuiButton-contained {
    background-color: ${(props) => props.theme.colors.primaryColor};
    &:hover {
      background-color: ${(props) => props.theme.colors.primaryColor};
    }
  }
  &.MuiButton-outlined {
    color: ${(props) => props.theme.colors.primaryColor};
    &:hover {
      background-color: ${(props) => props.theme.colors.primaryColor};
      color: ${(props) => props.theme.colors.whiteColor};
      border-color: ${(props) => props.theme.colors.primaryColor};
    }
  }
  &.MuiButton-text {
    color: ${(props) => props.theme.colors.primaryColor};
    border: none;
    &:hover {
      background-color: ${(props) => props.theme.colors.primaryColor};
      color: ${(props) => props.theme.colors.whiteColor};
    }
  }
  &.Mui-disabled {
    border-color: rgba(0, 0, 0, 0.12);
  }
`;

export const CommonButton: React.FC<ICommonButton> = ({
  label,
  onClick = () => null,
  endIcon = null,
  type = 'button',
  variant = 'contained',
  fullWidth = false,
  minWidth = '',
  disabled = false,
  className = '',
}) => {
  return (
    <DabaduButton
      type={type}
      variant={variant}
      endIcon={endIcon}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      minWidth={minWidth}
      className={className}
      // sx={{
      //   width: {
      //     xs: 200,
      //     sm: 300,
      //     md: 700,
      //     lg: 800,
      //     xl: 1000,
      //   }
      // }}
    >
      {label}
    </DabaduButton>
  );
};
